module.exports = __webpack_public_path__ + "5cc4cc8e993e6943f2bce3118240ee24.svg";


//////////////////
// WEBPACK FOOTER
// ./directives/apptemplatesTable/no_form_plus.svg
// module id = 449
// module chunks = 0